import { useFlags } from "launchdarkly-react-client-sdk";
import React from "react";
import { Helmet } from "react-helmet";
import type { Event } from "src/types";

const getTrackingScript = ({ provider, code }) => {
  if (!provider || !code) return null;
  switch (provider) {
    case "google_analytics":
      return (
        <Helmet>
          <script type="text/javascript">
            {`window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${code}');`}
          </script>
          <script
            src={`https://www.googletagmanager.com/gtag/js?id=${code}`}
            async
          ></script>
        </Helmet>
      );
    case "meta_pixel":
      return (
        <Helmet>
          <script type="text/javascript">
            {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${code}');
            fbq('track', 'PageView');`}
          </script>
          <img
            alt=""
            height="1"
            width="1"
            style={{ display: "none" }}
            src={`https://www.facebook.com/tr?id=${code}&ev=PageView&noscript=1`}
          />
        </Helmet>
      );

    default:
      return null;
  }
};

export default function TrackingProviders({ event }: { event: Event }) {
  const flags = useFlags();
  const { eventsEnableTrackingIntegrationsV2: useTrackingIntegrations } = flags;

  if (!event || useTrackingIntegrations === undefined) {
    return null;
  }

  const legacyAnalyticsCode = event?.marketing?.analytics_code;
  const trackingIntegrations = event?.tracking_integrations?.data || [];

  if (useTrackingIntegrations) {
    return (
      <>
        {trackingIntegrations.map(({ id: provider, attributes: { code } }) =>
          getTrackingScript({
            provider,
            code,
          })
        )}
      </>
    );
  }

  if (legacyAnalyticsCode) {
    return getTrackingScript({
      provider: "google_analytics",
      code: legacyAnalyticsCode,
    });
  }

  return null;
}
